import {
  Box,
  FormControl,
  Text,
  RadioGroup,
  Radio,
  Collapse,
} from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
import { useAppSelector } from '../../../store/redux/hooks';
import { useRef, useEffect, useState } from 'react';

const flash = keyframes`
  0% { background-color: rgba(0, 0, 0, 0.06); }
  100% { background-color: transparent; }
`;

const RADIO_GROUP_SX = {
  '.chakra-radio__control': {
    w: '16px !important',
    h: '16px !important',
    minW: '16px',
    minH: '16px',
  },
  '.chakra-radio__control[data-checked]': {
    bg: '#F0F0F0',
    borderColor: '#243744',
    color: '#243744',
    _hover: { bg: '#F0F0F0', borderColor: '#243744' },
    _before: { bg: '#243744' },
  },
  '.chakra-radio__control:hover': {
    borderColor: '#243744',
  },
  '.chakra-radio__label': {
    color: 'black',
    opacity: 1,
  },
};

interface OverrideRadioProps {
  isVisible: boolean;
  value: 'new' | 'all';
  onChange: (value: 'new' | 'all') => void;
  question?: string;
}

const OverrideRadio = ({
  isVisible,
  value,
  onChange,
  question = 'Who should this change apply to?',
}: OverrideRadioProps) => {
  const passesCount = useAppSelector((s) => s.template._passesCount);
  const prevVisibleRef = useRef(isVisible);
  const [shouldAnimate, setShouldAnimate] = useState(false);

  useEffect(() => {
    if (isVisible && !prevVisibleRef.current && passesCount > 0) {
      setShouldAnimate(true);
      const timer = setTimeout(() => setShouldAnimate(false), 2000);
      prevVisibleRef.current = isVisible;
      return () => clearTimeout(timer);
    }
    prevVisibleRef.current = isVisible;
  }, [isVisible, passesCount]);

  return (
    <Collapse in={isVisible && passesCount > 0}>
      <Box mt={0} ml={2} borderRadius="8px" p={2} animation={shouldAnimate ? `${flash} 2s ease-out` : undefined}>
        <FormControl isRequired>
          <Text fontSize="14px" fontFamily="Inter Regular, sans-serif" mb={2}>
            {question}
            <Text as="span" color="red">
              *
            </Text>
          </Text>
          <RadioGroup
            value={value}
            onChange={(val: 'new' | 'all') => onChange(val)}
            display="flex"
            flexDirection="column"
            gap={2}
            mt={4}
            sx={RADIO_GROUP_SX}
          >
            <Radio value="new">
              <Text fontSize="12px">New passes only</Text>
            </Radio>
            <Radio value="all">
              <Text fontSize="12px">
                New and existing {passesCount.toLocaleString()}{' '}
                {passesCount === 1 ? 'pass' : 'passes'}
              </Text>
            </Radio>
          </RadioGroup>
        </FormControl>
      </Box>
    </Collapse>
  );
};

export default OverrideRadio;
